// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"58d52073","251":"117b80d1","350":"9dca365a","585":"f03d6612","943":"0308ba2a"}[chunkId] + ".css";
};